import { useLanguage } from '@/i18n/LanguageContext';
import { PetBackdrop } from '@/components/PetBackdrop';
import { ASSETS } from '@/assets';

export const ProductDetail = () => {
  const { t } = useLanguage();
  return (
    <section id="benefits" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <PetBackdrop src={ASSETS.petsCorgi} className="-left-16 bottom-0 w-[460px] h-[460px] hidden lg:block" opacity={0.14} />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-2xl space-y-3 mb-14">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-orange">{t.product.overline}</p>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight text-brand-green">{t.product.title}</h2>
          <p className="text-base md:text-lg font-medium text-brand-green/80">{t.product.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {t.product.cards.map((card, i) => (
            <div
              key={card.title}
              className="bg-brand-bone/85 border-2 border-brand-green/10 rounded-3xl p-8 flex flex-col justify-between hover:-translate-y-1.5 hover:border-brand-orange/40 transition-all duration-300"
            >
              <div className="space-y-4">
                <span className={`font-display text-4xl leading-none ${i === 1 ? 'text-brand-green' : 'text-brand-orange'}`}>
                  {card.kicker}
                </span>
                <h3 className="font-display text-2xl uppercase text-brand-green">{card.title}</h3>
                <p className="text-sm font-medium text-brand-green/80 leading-relaxed">{card.text}</p>
              </div>
              <div className={`mt-6 pt-4 border-t-2 border-dashed border-brand-green/15 text-xs font-extrabold uppercase tracking-wider ${i === 1 ? 'text-brand-green' : 'text-brand-orange'}`}>
                {card.foot}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
